export const SoundTypes = {
  BACKGROUND: { name: 'background', category: 'background' },
  INTRO: { name: 'intro', category: 'generalInstructions' },

  WELCOME: { name: 'welcome', category: 'generalInstructions' },
  TAP_GAME: { name: 'tap-game', category: 'generalInstructions' },
  SELECT_NAME: { name: 'select-name', category: 'generalInstructions' },
  PICK_AND_PRACTICE: { name: 'pick-and-practice', category: 'generalInstructions' },

  HWT_WINNING_ORDER: { name: 'hwt-winning-order', category: 'generalInstructions' },
  THE_EASIEST_ORDER: { name: 'the-easiest-order', category: 'generalInstructions' },
  EARN_A_STAR_LETTER: { name: 'earn-a-star-letter', category: 'generalInstructions' },
  EARN_A_STAR_NUMBER: { name: 'earn-a-star-number,', category: 'generalInstructions' },

  SUCCESS: { name: 'success', category: 'instructions' },
  WON_STAR: { name: 'won-star', category: 'instructions' },
  WON_ANOTHER_STAR: { name: 'won-another-star', category: 'instructions' },
  WON_LETTER_CARD: { name: 'won-letter-card', category: 'instructions' },
  WON_NUMBER_CARD: { name: 'won-number-card', category: 'instructions' },
  CARD_DESCRIPTION: { name: 'card-description', category: 'instructions' },

  REVERSAL: { name: 'reversal', category: 'instructions' },
  FINGER_DOWN: { name: 'finger-down', category: 'instructions' },
  OUT_OF_BOUNDS: { name: 'out-of-bounds', category: 'instructions' },
  REPLAY_DEMO: { name: 'replay-demo', category: 'instructions' },
  NOW_YOU: { name: 'now-you', category: 'instructions' },

  NOW_WET_LETTER: { name: 'now-wet-letter', category: 'instructions' },
  DRY_WITH_TOWEL: { name: 'dry-with-towel', category: 'instructions' },
  TRY_WITH_CHALK: { name: 'try-with-chalk', category: 'instructions' },

  NOW_WET_NUMBER: { name: 'now-wet-number', category: 'instructions' },
  DRY_NUMBER_WITH_TOWEL: { name: 'dry-number-with-towel', category: 'instructions' },
  TRY_NUMBER_WITH_CHALK: { name: 'try-number-with-chalk', category: 'instructions' },

  WATCH_FOR_CLUE: { name: 'watch-for-clue', category: 'instructions' },
  NO_CLUES: { name: 'no-clues', category: 'instructions' },

  DING_WRONG: { name: 'ding-wrong', category: 'effects' },
  DING_CORRECT: { name: 'ding-correct', category: 'effects' },
  DING_CONTINUE: { name: 'ding-continue', category: 'effects' },
  DING_PICKUP: { name: 'ding-pickup', category: 'effects' },
  CHALK: { name: 'chalk', category: 'effects' },
  PAPER: { name: 'paper', category: 'effects' },
  SPONGE: { name: 'sponge', category: 'effects' },
  BUTTON_CLICK: { name: 'button-click', category: 'effects' },

  LETS_TRY: { name: 'lets-try', category: 'instructions' },
  FIRST_WATCH_ME: { name: 'first-watch-me', category: 'instructions' },
  STARTS: { name: 'starts', category: 'instructions' },
  NOW_YOU_TRY: { name: 'now you-try', category: 'instructions' }
};
